import { c } from 'react-compiler-runtime';
import classes from './Divider.module.css.js';
import { jsx } from 'react/jsx-runtime';

function Divider() {
  const $ = c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/jsx("div", {
      "data-component": "ActionList.Divider",
      className: classes.Divider
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

/**
 * `Divider` fulfills the `ItemPropsWithCustomRenderer` contract,
 * so it can be used inline in an `ActionList`’s `items` prop.
 * In other words, `items={[ActionList.Divider]}` is supported as a concise
 * alternative to `items={[{renderItem: () => <ActionList.Divider />}]}`.
 */
Divider.renderItem = Divider;

export { Divider };
